import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { OrderStatusSuccessHeaderBlockConfig } from '@front-platform/content-builder';
import { orderStatusSuccessHeaderBlockResolveConfig } from '@front-platform/content-builder';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, input } from '@angular/core';

import { DoodOrderModel } from '@store/order/order.model';
import { OrderStoreSelector } from '@common/selectors/order.selector';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface OrderStatusSuccessHeaderBlockRuntimeConfig {}

export type OrderStatusSuccessHeaderBlockConfigInput = Partial<
  Omit<OrderStatusSuccessHeaderBlockConfig, keyof OrderStatusSuccessHeaderBlockRuntimeConfig> &
    OrderStatusSuccessHeaderBlockRuntimeConfig
>;
export type OrderStatusSuccessHeaderBlockResolvedConfig = Omit<
  OrderStatusSuccessHeaderBlockConfig,
  keyof OrderStatusSuccessHeaderBlockRuntimeConfig
> &
  Partial<OrderStatusSuccessHeaderBlockRuntimeConfig>;
export interface OrderStatusSuccessHeaderBlockContract extends ConfigComponentContract<
  OrderStatusSuccessHeaderBlockConfigInput,
  OrderStatusSuccessHeaderBlockResolvedConfig
> {}

@Component({
  selector: 'app-order-status-success-header-block',
  templateUrl: './order-status-success-header-block.component.html',
  standalone: false,
})
export class OrderStatusSuccessHeaderBlockComponent
  implements OnInit, OrderStatusSuccessHeaderBlockContract
{
  readonly config = input<OrderStatusSuccessHeaderBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    OrderStatusSuccessHeaderBlockConfig,
    OrderStatusSuccessHeaderBlockRuntimeConfig
  >(orderStatusSuccessHeaderBlockResolveConfig, () => ({ config: this.config() }));
  private _textConfigOverride: string | undefined | undefined;
  get text(): string | undefined {
    return (
      this._textConfigOverride ?? (this.resolvedConfig()['text'] as unknown as string | undefined)
    );
  }
  set text(value: string | undefined) {
    this._textConfigOverride = value;
  }
  get textColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor;
  }

  order: DoodOrderModel | null = null;

  constructor(
    private orderSelector: OrderStoreSelector,
    private readonly translate: TranslateService,
  ) {
    this.orderSelector.selectActive.subscribe(order => {
      this.order = order;
    });
  }

  ngOnInit(): void {
    if (!this.text) {
      this.translate.get('order.order-validate').subscribe(text => (this.text = text));
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(OrderStatusSuccessHeaderBlockComponent, {
  'keyAliases': {},
});
